import { VerifyPasswordResetRequest } from '@/api/models/ace/xFound/Portal/Core/CAQ/Authentication/Requests/verify-password-reset-request';
import { I18nService } from '@/core/services/i18nService';
import { LoadingAnimationService } from '@/core/services/loading-animation.service';
import { Component, OnInit } from '@angular/core';
import { AbstractControl, UntypedFormBuilder, UntypedFormGroup, ValidationErrors, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { NotificationService } from '@progress/kendo-angular-notification';
import { Subscription } from 'rxjs';
import { finalize } from 'rxjs/operators';
import { ExtendedAuthenticationService } from '../../services/extended-authentication.service';
import { emailValidator } from '@/core/validators/customform.validators';
import { StammdatenService } from '@/core/services/stammdaten.service';

@Component({
  selector: 'mail-verification',
  templateUrl: './mail-verification.component.html',
  styleUrls: ['./mail-verification.component.scss']
})
export class MailVerificationComponent {

  requestPasswordResetForm: UntypedFormGroup;
  sendResetMailSubscription : Subscription;

  public get benutzernameFormControl(): AbstractControl {
    return this.requestPasswordResetForm.controls["email"];
  }

  public get benutzernameErrorMessages(): string[] {
    let validationErrors: ValidationErrors | null = this.benutzernameFormControl.errors;

    if(!validationErrors)
      return [];

    return this.toBenutzernameErrorMessage(validationErrors);
  }

  constructor(protected router: Router,
    protected route: ActivatedRoute,
    protected formBuilder: UntypedFormBuilder,
    protected authenticationService: ExtendedAuthenticationService,
    protected loadingAnimationService: LoadingAnimationService,
    protected notificationService: NotificationService,
    protected stammdatenService: StammdatenService,
    protected languageservice: I18nService) {

    this.createForm();
  }

  public get isLoading() : boolean{
    return this.sendResetMailSubscription && !this.sendResetMailSubscription.closed;
  }

  public get isRegistrationDisabled(): boolean {
    return this.stammdatenService.Portalkonfiguration.registrationIsDisabled == true;
  }

  sendResetMail(){
    let request = new VerifyPasswordResetRequest();
    request.email = this.requestPasswordResetForm.get("email")?.value;

    this.sendResetMailSubscription = this.authenticationService.apiAuthenticationVerifyPasswordResetPost(request.AsRequestBody())
    .pipe(finalize(() => {
      this.requestPasswordResetForm.markAsPristine();
    }))
    .subscribe(()=> {
      let promise = this.router.navigateByUrl('/authentication/mailconfirmation?from=reset-password')
      this.loadingAnimationService.showSpinnerUsingPromise(promise);
    });

    this.loadingAnimationService.showSpinnerUsingSubscription(this.sendResetMailSubscription);
  }

  public get emailValidated() : boolean {
    return this.requestPasswordResetForm.controls.email.valid || this.requestPasswordResetForm.controls.email.untouched;
  }

  protected toBenutzernameErrorMessage(validationErrors: ValidationErrors) : string[] {
    let errorMessages: string[] = [];

    for(let key in validationErrors){
      switch(key){
        case "required":
          errorMessages.push(this.languageservice.instant("register.email_required"));
          break;
        case "email":
          errorMessages.push(this.languageservice.instant("register.email_invalid"));
            break;
        default:
          errorMessages.push(this.languageservice.instant("register.invalid"));
      }
    }

    return errorMessages;
  }

  protected createForm(){
    this.requestPasswordResetForm = this.formBuilder.group({
      email: ['', [Validators.required, emailValidator]]
    });
  }

}
